import { DataDirection } from '../../../core/types/ui/position';
import { SheetDefaults } from '../../constants/sheetDefaults';
import {
  Col,
  EntitySize,
  FilterResults,
  Freeze,
  IRange,
  Row,
  Sheet,
  SheetView,
} from '../../types';
import { getEntitySize } from '../viewport/viewportUtils';
import {
  IterataeViewportConfigs,
  IterateViewportParams,
  getUnHiddenPosition,
  getViewportStartEnd,
  iterateViewportBackward,
  iterateViewportForward,
} from '../views/virtualViewport';

const MIN_ROW_HEADER_WIDTH = 12;
export const getRowHeaderWidth = (rowEnd = 0, zoom: number) =>
  Math.max(
    rowEnd.toString().length * MIN_ROW_HEADER_WIDTH,
    SheetDefaults.rowHeaderWidth
  ) * zoom;

export const createViewportForward = <T extends Col | Row>(
  start: number,
  end: number,
  entitySizes: EntitySize[],
  // entries: T[],
  defaultSize: number,
  hiddenRanges: IRange[],
  zoom: number,
  freeze: Freeze,
  filterResults?: FilterResults,
  maxSize = 0,
  configs: Partial<IterataeViewportConfigs> = {}
) => {
  const indexes: number[] = [];
  const sizes: number[] = [];
  let sum = 0;
  let sizeExceedsMax = false;
  // let endIndex = start;

  const cb = ({ size, index }: IterateViewportParams) => {
    sum += size;
    indexes.push(index);
    sizes.push(size);

    if (maxSize && sum >= maxSize) {
      sizeExceedsMax = true;
      // endIndex = index;
      return true;
    }

    return false;
  };
  iterateViewportForward(
    start,
    end,
    entitySizes,
    hiddenRanges,
    cb,
    freeze,
    defaultSize,
    zoom,
    filterResults,
    configs
  );

  return {
    indexes,
    sizes,
    sizeExceedsMax,
    // end: endIndex,
    sum,
  };
};

export const createViewportBackward = <T extends Col | Row>(
  start: number,
  end: number,
  // entries: T[],
  entitySizes: EntitySize[],
  defaultSize: number,
  max: number,
  hiddenRanges: IRange[],
  zoom: number,
  freeze: Freeze,
  filterResults?: FilterResults,
  maxSize = 0,
  configs: Partial<IterataeViewportConfigs> = {}
) => {
  const indexes: number[] = [];
  const sizes: number[] = [];

  let sum = 0;
  let sizeExceedsMax = false;
  // let startIndex = end;
  // let endIndex = end;

  const cb = ({ size, index }: IterateViewportParams) => {
    sum += size;

    if (maxSize) {
      if (sum === maxSize) {
        indexes.unshift(index);
        sizes.unshift(size);
        // startIndex = index;
        return true;
      } else if (sum > maxSize) {
        // TODO: Handle Fix un hidden row col function
        sizeExceedsMax = true;
        const { end } = getViewportStartEnd(indexes);
        if (end !== -1) {
          const endIndex = getUnHiddenPosition(
            entitySizes,
            hiddenRanges,
            end,
            max,
            DataDirection.Forward,
            freeze,
            filterResults,
            1
          );
          if (!indexes.includes(endIndex)) {
            indexes.push(endIndex);
            sizes.push(getEntitySize(entitySizes, endIndex, defaultSize, zoom));
          }
        } else {
          indexes.push(index);
          sizes.push(size);
        }
        return true;
      } else {
        indexes.unshift(index);
        sizes.unshift(size);
      }
    }
    return false;
  };
  iterateViewportBackward(
    start,
    end,
    entitySizes,
    hiddenRanges,
    cb,
    freeze,
    defaultSize,
    zoom,
    filterResults,
    configs
  );
  return {
    indexes,
    sizes,
    sizeExceedsMax,
    // start: startIndex,
    // end: endIndex,
    sum,
  };
};

export const getEntitiesData = (
  sheet: Pick<
    Sheet,
    | 'colSizes'
    | 'rowSizes'
    | 'hiddenCols'
    | 'hiddenRows'
    | 'maxColIndex'
    | 'maxRowIndex'
    | 'freezedCols'
    | 'freezedRows'
  >,
  sheetView: Pick<SheetView, 'filterResults'>,
  isCol: boolean
) => ({
  entitySizes: isCol ? sheet.colSizes : sheet.rowSizes,
  hiddenRanges: isCol ? sheet.hiddenCols : sheet.hiddenRows,
  maxIndex: isCol ? sheet.maxColIndex : sheet.maxRowIndex,
  freeze: isCol ? sheet.freezedCols : sheet.freezedRows,
  filterResults: isCol ? undefined : sheetView.filterResults,
});
